import axios from 'axios';
import {config} from '@shared/_services/config';

export const HTTP = axios.create({
    baseURL: config.baseUrl,
    timeout: 300000
});

var requestInterceptor = HTTP.interceptors.request.use (
    function (config) {

        let user = window.$cookies.get('user');
        if (user && user.token) {
            config.headers.Authorization = `Bearer ${user.token}`;
        }

        return config;
    },
    function (error) {
        return Promise.reject (error);
    }
);

var responseInterceptor = HTTP.interceptors.response.use(
    response => response,
    error => {
        if (error.status === 401 || (error.response && error.response.status === 401)) {
            axios.interceptors.response.eject(responseInterceptor);
            window.$cookies.remove('user');
        } else {

            let errorResponse = error.response;

            if (errorResponse && (error.message || errorResponse.data)) {
                return Promise.reject({
                    status : errorResponse.status,
                    messages: error.message,
                    errorCode: errorResponse.data ? errorResponse.data.exceptionCode : null
                });

            }

            return Promise.reject(error);
        }


    }
);